import { FunctionComponent } from 'react';
import SourceModal from '../SourceModal/SourceModal';
;
const ModalBox: FunctionComponent = () => {
    return <SourceModal />;
};

export default ModalBox;
